module.exports = __webpack_public_path__ + "img/Rob Holding.a88fb39c.png";